// React
import { ReactNode } from "react"

// UI
import { HeaderNoAuth } from "@/components/navigation/HeaderNoAuth"
import { FooterNoAuth } from "@/components/navigation/FooterNoAuth"

/**
 * NoAuthLayout
 * Renders the children without any authentication or authorization checks
 * Displays the branded header
 *
 * @param param0
 * @returns
 */
export function NoAuthLayout({ children }: { children: ReactNode }) {
	return (
		<>
			<HeaderNoAuth />

			<div className="flex items-center justify-center bg-[#f8f8f8] px-4">
				<div>{children}</div>
			</div>

			<FooterNoAuth />
		</>
	)
}
